// src/dataProvider.js - ЗАМЕНИТЕ ВЕСЬ getList МЕТОД
import { fetchUtils } from "react-admin";
import { stringify } from "query-string";
import { apiUrl } from "./authProvider";

const httpClient = (url, options = {}) => {
  options.credentials = "include";

  const token = localStorage.getItem("token");

  if (!options.headers) {
    options.headers = new Headers();
  }

  if (token) {
    options.headers.set("Authorization", `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(url, options);
};

/**
 * Кастомный Data Provider для react-admin
 */
const dataProvider = {
  getList: async (resource, params) => {
    console.log("🔥 getList ВЫЗВАН для:", resource, params);

    if (resource === "messages") {
      console.log("🎯 Обрабатываем messages...");

      const { page = 1, perPage = 10 } = params.pagination || {};
      const { field = "id", order = "DESC" } = params.sort || {};

      // Фильтры
      const { chat_id } = params.filter || {};

      // Query параметры
      const query = {};

      // Фильтрация
      if (chat_id !== undefined && chat_id !== "") {
        query.chart_id = chat_id;
      }

      // Пагинация
      query.skip = (page - 1) * perPage;
      query.limit = perPage;

      // Сортировка
      if (field === "id") {
        query.order_by = field;
        query.order_desc = order === "DESC";
      }

      const url = `${apiUrl}/messages/?${new URLSearchParams(
        query
      ).toString()}`;
      console.log("🌐 Запрос messages:", url);

      try {
        const response = await httpClient(url);
        console.log("✅ Messages ответ получен");

        const json = response.json || [];
        console.log("📊 Messages данные:", json);

        const dataWithIds = json.map((item, index) => ({
          ...item,
          id:
            item.id || `message_${item.manager_id}_${item.project_id}_${index}`,
        }));

        return {
          data: dataWithIds,
          total: json.length || 0,
        };
      } catch (error) {
        console.error("❌ Ошибка messages:", error);

        return {
          data: [],
          total: 0,
        };
      }
    }

    // =========== ОБРАБОТКА ДРУГИХ РЕСУРСОВ ===========
    console.log(`📦 Обрабатываем общий ресурс: ${resource}`);

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { field = "id", order = "ASC" } = params.sort || {};

    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(params.filter || {}),
    };

    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    console.log("🌐 Общий запрос:", url);

    try {
      const response = await httpClient(url);
      const json = response.json || [];

      return {
        data: json,
        total: json.length || 0,
      };
    } catch (error) {
      console.error(`❌ Ошибка ${resource}:`, error);
      return {
        data: [],
        total: 0,
      };
    }
  },

  // ... остальные методы без изменений
  getOne: async (resource, params) => {
    let url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url);
    return { data: json };
  },

  getMany: async (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const { json } = await httpClient(url);
    return { data: json };
  },

  getManyReference: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };

    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const { json } = await httpClient(url);

    return {
      data: json,
      total: json.length || 0,
    };
  },

  update: async (resource, params) => {
    let url = `${apiUrl}/${resource}/${params.id}`;

    if (resource === "users") {
      url = `${apiUrl}/auth/update/`;
    }

    const { json } = await httpClient(url, {
      method: "PUT",
      body: JSON.stringify(params.data),
    });

    return { data: json };
  },

  updateMany: async (resource, params) => {
    const responses = await Promise.all(
      params.ids.map((id) =>
        httpClient(`${apiUrl}/${resource}/${id}`, {
          method: "PUT",
          body: JSON.stringify(params.data),
        })
      )
    );

    return { data: responses.map((response) => response.json) };
  },

  create: async (resource, params) => {
    let url = `${apiUrl}/${resource}`;
    let body = params.data;

    const { json } = await httpClient(url, {
      method: "POST",
      body: JSON.stringify(body),
    });

    return { data: json };
  },

  delete: async (resource, params) => {
    console.log(resource, "--", params);
    if (resource == "videos") resource = "video";
    if (resource == "comments") resource = "video/comments";

    let url = `${apiUrl}/${resource}/${params.id}`;

    if (resource == "cities")
      url = `${apiUrl}/${resource}/${params.previousData.name}`;

    if (resource == "faculties")
      url = `${apiUrl}/${resource}/${params.previousData.name}`;

    if (resource == "tags")
      url = `${apiUrl}/${resource}/${params.previousData.name}`;

    await httpClient(url, {
      method: "DELETE",
    });

    return { data: {} };
  },

  deleteMany: async (resource, params) => {
    await Promise.all(
      params.ids.map((id) =>
        httpClient(`${apiUrl}/${resource}/${id}`, {
          method: "DELETE",
        })
      )
    );

    return {};
  },
};

export default dataProvider;
